const SHOW_INFO = {
    LOG: false,
    DATA: false,
    ERROR: false,
    WARN: false,
}

const SHOW_REQUEST_INFO = {
    REQUEST: false,
    HEADER: false,
    BODY: false,
    RESPONSE: false,
}

const ROUTE_INDEX = '/conferencia'

const APP_VERSION = {
    NAME: '1.19.1',
    RELEASE_DATE: '17/05/2024',
}

const config = {
    SHOW_INFO, SHOW_REQUEST_INFO, APP_VERSION, ROUTE_INDEX
}

export default config
export { SHOW_INFO, SHOW_REQUEST_INFO, APP_VERSION, ROUTE_INDEX }